// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spt.scss
// module id = 725
// module chunks = 0